<div #dropdown="ngbDropdown" [placement]="placement()" ngbDropdown xmlns="http://www.w3.org/1999/html" [attr.data-test]="testAttribute()">
  <button
    [attr.aria-label]="ariaLabel()"
    [disabled]="disabled()"
    [ngClass]="[buttonSize(), buttonColor()]"
    aria-haspopup="listbox"
    aria-labelledby="dropdown-label"
    class="btn w-100 w-md-auto"
    id="dropdown-input-{{ ariaLabel() }}"
    ngbDropdownToggle
    type="button"
    #togglebtn
  >
    <span class="text-start text-truncate">
      @if (prefix()) {
        {{ prefix() | translate }}:
      }
      {{ currentValue().text | translate }}
    </span>
    <i [ngClass]="{ 'rotate-x-180': dropdown._open }" aria-hidden="true" class="fas fa-chevron-down transition-all text-white ml-2"></i>
  </button>
  <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu role="listbox">
    @for (option of options(); track option) {
      <button
        ngbDropdownItem
        type="button"
        class="dropdown-item"
        role="option"
        (click)="selectDropdown(option)"
        [ngClass]="{ 'dropdown-item-checked': isOptionSelected(option) }"
        [attr.aria-selected]="isOptionSelected(option) || null"
        [attr.data-test]="testAttribute() + '-option'"
      >
        <span class="text-truncate">{{ option.text | translate }}</span>
      </button>
    }
  </div>
</div>
